/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface ThresholdPrice
 */
export interface ThresholdPrice {
    /**
     * 
     * @type {number}
     * @memberof ThresholdPrice
     */
    fromAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdPrice
     */
    toAmount?: number;
    /**
     * 
     * @type {Price}
     * @memberof ThresholdPrice
     */
    price: Price;
}

/**
 * Check if a given object implements the ThresholdPrice interface.
 */
export function instanceOfThresholdPrice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "price" in value;

    return isInstance;
}

export function ThresholdPriceFromJSON(json: any): ThresholdPrice {
    return ThresholdPriceFromJSONTyped(json, false);
}

export function ThresholdPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThresholdPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromAmount': !exists(json, 'fromAmount') ? undefined : json['fromAmount'],
        'toAmount': !exists(json, 'toAmount') ? undefined : json['toAmount'],
        'price': PriceFromJSON(json['price']),
    };
}

export function ThresholdPriceToJSON(value?: ThresholdPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromAmount': value.fromAmount,
        'toAmount': value.toAmount,
        'price': PriceToJSON(value.price),
    };
}

